import { Link } from 'react-router-dom'
import { appRoutes } from '@/constants'

export function PublicFooter() {
  return (
    <footer className="w-full bg-background py-10">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8">
        <div className="rounded-[28px] border border-border bg-card p-8 sm:p-12 shadow-xl space-y-12 transition-colors">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-xs">
            
            {/* Col 1: Corporate Office */}
            <div className="space-y-3">
              <span className="text-[10px] font-bold text-[#CF2F2F] uppercase tracking-wider block">CORPORATE OFFICE</span>
              <p className="text-foreground leading-relaxed font-medium">
                6th Floor, SAS Tower-C, CH Baktawar Road, Medicity, Sector 38, Shivaji Nagar, Gurgaon, 122001, Haryana
              </p>
              <div className="pt-2 space-y-2">
                <span className="text-[10px] font-bold text-foreground/70 block flex items-center gap-1">
                  🛡️ RBI Registered NBFC
                </span>
                <div className="flex items-center gap-2 pt-1">
                  {['F', 'T', 'I', 'In'].map((social, i) => (
                    <span
                      key={i}
                      className="h-7 w-7 rounded-full bg-foreground text-card flex items-center justify-center text-[10px] font-bold hover:bg-[#CF2F2F] hover:text-white transition-colors cursor-pointer"
                    >
                      {social}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Col 2: Company */}
            <div className="space-y-3">
              <h5 className="font-extrabold text-foreground uppercase tracking-wider">COMPANY</h5>
              <ul className="space-y-2 text-muted-foreground font-medium">
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">About Us</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Careers</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Blog</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Testimonials</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Privacy Policy</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Terms &amp; Conditions</Link></li>
              </ul>
            </div>

            {/* Col 3: Discover */}
            <div className="space-y-3">
              <h5 className="font-extrabold text-foreground uppercase tracking-wider">DISCOVER</h5>
              <ul className="space-y-2 text-muted-foreground font-medium">
                <li><Link to={appRoutes.cars} className="hover:text-[#CF2F2F] transition-colors">Buy a Used Car</Link></li>
                <li><Link to={appRoutes.cars} className="hover:text-[#CF2F2F] transition-colors">Sell a Used Car</Link></li>
                <li><Link to={appRoutes.parts} className="hover:text-[#CF2F2F] transition-colors">Spare Parts</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Find Dealers</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Car Valuation</Link></li>
              </ul>
            </div>

            {/* Col 4: Help & Support */}
            <div className="space-y-3">
              <h5 className="font-extrabold text-foreground uppercase tracking-wider">HELP &amp; SUPPORT</h5>
              <ul className="space-y-2 text-muted-foreground font-medium">
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">FAQs</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Contact Us</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Terms of Service</Link></li>
                <li><Link to={appRoutes.home} className="hover:text-[#CF2F2F] transition-colors">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>

          {/* Copyright Row */}
          <div className="border-t border-border/60 pt-6 flex flex-col sm:flex-row items-center justify-between text-[11px] text-muted-foreground gap-2">
            <p>&copy; 2026 Exotic Autocart Professional. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <Link to={appRoutes.home} className="hover:text-foreground">Terms</Link>
              <span>•</span>
              <Link to={appRoutes.home} className="hover:text-foreground">Privacy</Link>
            </div>
          </div>

          {/* GIANT BRAND WATERMARK TEXT AT BOTTOM */}
          <div className="pt-4 text-center overflow-hidden">
            <h1
              style={{ fontFamily: "'Poppins', 'DM Sans', sans-serif" }}
              className="text-[clamp(2.5rem,8vw,7rem)] font-extrabold tracking-tight text-[#CF2F2F] uppercase whitespace-nowrap opacity-90 leading-none select-none"
            >
              EXOTIC AUTO CART
            </h1>
          </div>
        </div>
      </div>
    </footer>
  )
}
